import { Switch } from 'core-components/library/checkbox'
import { isEmpty, ValidateInput } from 'core-components/library/validation'
import { IStaticPropertiesMapping } from 'core-components/sitebuilder/models/IMetaInformation'
import { IStaticProps } from 'core-components/sitebuilder/models/IWidget'

import { DropdownEditor } from './DropdownEditor'
import { MultiSelectEditor } from './MultiSelectEditor'
import { ObjectEditor } from './ObjectEditor'

import styles from './ValueEditor.module.scss'

interface IValueEditor {
  staticElement: IStaticProps | undefined
  isRequired: boolean
  onChange: (newValue: string | string[] | boolean | number | IStaticProps[]) => void
  dropdownItems?: IStaticPropertiesMapping['dropdownItems']
  dropdownSource?: IStaticPropertiesMapping['dropdownSource']
}

export const ValueEditor = ({
  staticElement,
  isRequired,
  onChange,
  dropdownItems,
  dropdownSource,
}: IValueEditor) => {
  if (staticElement?.paramType === 'boolean') {
    return (
      <Switch
        className={styles.inputWidth}
        checked={!!staticElement?.paramValue}
        onChange={onChange}
      />
    )
  }

  if (staticElement?.paramType === 'object' || staticElement?.paramType === 'array') {
    return (
      <ObjectEditor
        editorType={staticElement.paramType}
        value={(staticElement.paramValue as IStaticProps[]) || []}
        onChange={onChange}
      />
    )
  }

  if (staticElement?.paramType === 'dropdown') {
    return (
      <DropdownEditor
        className={styles.inputWidth}
        onChange={onChange}
        value={`${staticElement?.paramValue || ''}`}
        dropdownItems={dropdownItems}
        dropdownSource={dropdownSource}
        paramName={staticElement.paramName}
      />
    )
  }

  if (staticElement?.paramType === 'multiselect') {
    return (
      <MultiSelectEditor
        className={styles.inputWidth}
        onChange={onChange}
        value={(staticElement?.paramValue as string[]) || []}
        dropdownItems={dropdownItems}
        dropdownSource={dropdownSource}
        paramName={staticElement.paramName}
      />
    )
  }

  return (
    <ValidateInput
      classes={{ validatorClasses: { root: styles.inputWidth } }}
      label={'Parameter value'}
      type={staticElement?.paramType === 'number' ? 'number' : undefined}
      value={`${staticElement?.paramValue || ''}`}
      checkFn={isRequired ? isEmpty : null}
      onChange={onChange}
    />
  )
}
